module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/3-b069e15d345262a56f219f26dc8931f5.jpg";